<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div class="bg-background-100 flex max-w-xl flex-col gap-4 p-8">
  <h1 class="text-xl">{{ dialogData.title }}</h1>

  @if (dialogData.subTitle) {
    <h2 class="text-lg" data-test-id="dialog-sub-title">{{ dialogData.subTitle }}</h2>
  }

  <p>
    @if (dialogData.withWarning) {
      <strong data-test-id="dialog-warning-prefix">Achtung:</strong>
    }
    {{ dialogData.description }}
  </p>

  @if ((deleteStateResource$ | async)?.error; as error) {
    <div role="alert" data-test-id="dialog-error-message">
      @for (message of error | convertProblemDetailToErrorMessages; track message) {
        <ods-error-message [text]="message" />
      }
    </div>
  }

  <div class="flex justify-between">
    <ods-button
      (clicked)="closeDialog()"
      variant="outline"
      text="Abbrechen"
      dataTestId="dialog-cancel-button-native"
      data-test-id="dialog-cancel-button"
    />

    <odc-button-with-spinner
      [stateResource]="deleteStateResource$ | async"
      (clicked)="delete()"
      [text]="dialogData.deleteButtonText"
      dataTestId="dialog-delete-button-native"
      data-test-id="dialog-delete-button"
    />
  </div>
</div>
